import React from 'react';
import d1 from "../../../images/doctors-img/doctor_1.png"
import d2 from "../../../images/doctors-img/doctor_2.png"
import d3 from "../../../images/doctors-img/doctor_3.png"
import d4 from "../../../images/doctors-img/doctor_4.png"
import "./doctorpart.css";
const DoctorPart = () => {
  return (
    <section className="doctor_part section_padding">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-8">
            <div className="section_tittle text-center">
              <h2 className='section-title'>Experienced Doctors</h2>
              <p>Doctor Care boasts a team of highly experienced and skilled doctors, each dedicated to providing the best in medical care. Our commitment to excellence ensures that you receive top-tier treatment tailored to your unique needs.</p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6 col-lg-3">
            <div className="single_blog_item">
              <div className="single_blog_img">
                <img src={d1} alt="doctor" />
                <div className="social_icon">
                  <ul>
                    <li><a href="#"> <i className="ti-facebook"></i> </a></li>
                    <li><a href="#"> <i className="ti-twitter-alt"></i> </a></li>
                    <li><a href="#"> <i className="ti-instagram"></i> </a></li>
                    <li><a href="#"> <i className="ti-skype"></i> </a></li>
                  </ul>
                </div>
              </div>
              <div className="single_text">
                <div className="single_blog_text">
                  <h3>DR Adam Billiard</h3>
                  <p>Heart specialist</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-lg-3">
            <div className="single_blog_item">
              <div className="single_blog_img">
                <img src={d2} alt="doctor" />
                <div className="social_icon">
                  <ul>
                    <li><a href="#"> <i className="ti-facebook"></i> </a></li>
                    <li><a href="#"> <i className="ti-twitter-alt"></i> </a></li>
                    <li><a href="#"> <i className="ti-instagram"></i> </a></li>
                    <li><a href="#"> <i className="ti-skype"></i> </a></li>
                  </ul>
                </div>
              </div>
              <div className="single_text">
                <div className="single_blog_text">
                  <h3>DR Adam Billiard</h3>
                  <p>Medicine specialist</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-lg-3">
            <div className="single_blog_item">
              <div className="single_blog_img">
                <img src={d3} alt="doctor" />
                <div className="social_icon">
                  <ul>
                    <li><a href="#"> <i className="ti-facebook"></i> </a></li>
                    <li><a href="#"> <i className="ti-twitter-alt"></i> </a></li>
                    <li><a href="#"> <i className="ti-instagram"></i> </a></li>
                    <li><a href="#"> <i className="ti-skype"></i> </a></li>
                  </ul>
                </div>
              </div>
              <div className="single_text">
                <div className="single_blog_text">
                  <h3>DR Fred Macyard</h3>
                  <p>CHeart specialist</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-lg-3">
            <div className="single_blog_item">
              <div className="single_blog_img">
                <img src={d4} alt="doctor" />
                <div className="social_icon">
                  <ul>
                    <li><a href="#"> <i className="ti-facebook"></i> </a></li>
                    <li><a href="#"> <i className="ti-twitter-alt"></i> </a></li>
                    <li><a href="#"> <i className="ti-instagram"></i> </a></li>
                    <li><a href="#"> <i className="ti-skype"></i> </a></li>
                  </ul>
                </div>
              </div>
              <div className="single_text">
                <div className="single_blog_text">
                  <h3>DR Justin Stuard</h3>
                  <p>Heart specialist</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DoctorPart;
